import { DatePicker, Form, Select } from "antd";
import moment from "moment";

import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { TaxDeclarationType } from "../../../../../api/graphql/schema.generated";
import type { ResetDeclarationApprovalValues } from "./types";

export const initialResetDeclarationApprovalValues: Partial<ResetDeclarationApprovalValues> =
  {
    date: moment(),
    declarationType: TaxDeclarationType.EUER,
  };

const declarationTypeOptions: { value: TaxDeclarationType; label: string }[] = [
  { value: TaxDeclarationType.EUER, label: "EÜR" },
  { value: TaxDeclarationType.VAT_ANNUAL, label: "USt" },
  { value: TaxDeclarationType.TRADE_TAX, label: "GewSt" },
  { value: TaxDeclarationType.INCOME_TAX, label: "ESt" },
];

const getTexts = (t: TFunction) => {
  const keyPrefix = "command.resetDeclarationApproval";
  return {
    date: {
      label: t(`${keyPrefix}.date.label`),
      placeholder: t(`${keyPrefix}.date.placeholder`),
    },
    declarationType: {
      label: t(`${keyPrefix}.declarationType.label`),
      placeholder: t(`${keyPrefix}.declarationType.placeholder`),
    },
  };
};

export const ResetDeclarationApproval: React.FC = () => {
  const { t } = useTranslation("CommandHub");
  const texts = getTexts(t);
  return (
    <>
      <Form.Item name="date" label={texts.date.label}>
        <DatePicker
          id="date"
          placeholder={texts.date.placeholder}
          picker="year"
          disabledDate={(date: moment.Moment) =>
            date && date.year() > moment().year()
          }
        />
      </Form.Item>
      <Form.Item name="declarationType" label={texts.declarationType.label}>
        <Select
          id="declarationType"
          placeholder={texts.declarationType.placeholder}
          options={declarationTypeOptions}
        />
      </Form.Item>
    </>
  );
};
